import { useTranslation } from 'react-i18next';
import { Form, FormActions, Modal, TextAreaInput } from 'ui';

type FormValues = {
  reason?: string;
};

type P = {
  isOpened: boolean;
  onCancel?: () => void;
  onFinish: (message?: string) => Promise<void> | void;
};

const RequestJoinModal = ({ onFinish, ...rest }: P) => {
  const { t } = useTranslation();

  const handleFormFinish = async (values: FormValues) => onFinish(values.reason);

  return (
    <Modal title="Request to Join" {...rest} width="medium">
      <Modal.HugContent>
        <Form<FormValues> onFinish={handleFormFinish}>
          <TextAreaInput
            item={{
              label: t('Message'),
              name: 'reason',
            }}
          />
          <Modal.HugContent.Footer>
            <FormActions right={{ children: 'Cancel', onClick: rest.onCancel }} submit={{ children: 'Send' }} />
          </Modal.HugContent.Footer>
        </Form>
      </Modal.HugContent>
    </Modal>
  );
};

export default RequestJoinModal;
